"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pagination = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const styled_components_1 = __importStar(require("styled-components"));
const selectListElementStyles = (0, styled_components_1.css)(({ theme: { palette } }) => (0, styled_components_1.css) `
    color: ${palette.primary.main};
    background-color: ${palette.grey.A200};
  `);
exports.Pagination = (0, styled_components_1.default)(({ className, ...props }) => ((0, jsx_runtime_1.jsx)(material_1.TablePagination, { ...props, component: "div", classes: {
        root: className,
        toolbar: 'toolbar',
        spacer: 'spacer',
        selectRoot: 'selectRoot',
    }, SelectProps: {
        MenuProps: {
            classes: {
                root: className,
                paper: 'selectMenu',
                list: 'selectMenuList',
            },
        },
        classes: {
            icon: 'selectIcon',
        },
    } })))(({ theme: { palette } }) => (0, styled_components_1.css) `
    width: 100%;

    & .toolbar {
      padding-left: 0px;
      color: ${palette.grey[900]};
    }

    & .selectRoot {
      font-size: 12px;
      margin: 0 8px 0 0;
      font-weight: 700;

      & div {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    & .spacer {
      display: none;
    }

    & .selectMenu {
      background-color: ${palette.grey.A200};
      border: 1px solid ${palette.grey[500]};
      box-shadow: none;
    }

    & .selectIcon {
      position: absolute;
      top: 50%;
      right: 0;
      transform: translate(0, -50%);
    }

    & .selectMenuList {
      color: ${palette.grey[900]};
      padding: 2px 0;

      & li {
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: 1px solid ${palette.grey[500]};
        cursor: pointer;
        font-size: 14px;
        font-weight: 600;

        &:last-child {
          border-bottom: none;
        }

        &:hover {
          color: ${palette.primary.main};
        }

        &:focus {
          ${selectListElementStyles}
        }
        &.Mui-selected {
          ${selectListElementStyles}
        }
        &.Mui-selected:hover {
          ${selectListElementStyles}
        }
        &.Mui-selected:active {
          ${selectListElementStyles}
        }
        &.Mui-selected:focus {
          ${selectListElementStyles}
        }
      }
    }
  `);
